import { useMemo } from 'react';
import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { heroInsightBulletsApiClient } from './HeroInsightBullets.apiClient';
const DEFAULT_TOTAL_ROWS = 2;
export const useHeroInsightBullets = function (domain, _temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$totalRows = _ref.totalRows,
    totalRows = _ref$totalRows === void 0 ? DEFAULT_TOTAL_ROWS : _ref$totalRows;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _heroInsightBulletsAp = heroInsightBulletsApiClient.hooks.useHeroInsightBullets({
      domain
    }, true, {
      staleTime: Infinity,
      cacheTime: Infinity,
      useErrorBoundary: false
    }),
    data = _heroInsightBulletsAp.data;
  const insightIndexes = data == null ? void 0 : data.insightIndexes;
  return useMemo(() => {
    const tld = parseDomain(domain).tld;
    const resolveBullet = index => {
      const tldKey = `domain_search_gate.insight_widget.fallback_insight.${tld}.insight_${index + 1}`;
      const tldValue = t(tldKey);
      if (tldValue !== tldKey) {
        return tldValue;
      }
      return t(`domain_search_gate.insight_widget.fallback_insight.generic.insight_${index + 1}`);
    };
    return (insightIndexes ?? []).slice(0, totalRows).map(resolveBullet);
  }, [domain, insightIndexes, t, totalRows]);
};
//# sourceMappingURL=useHeroInsightBullets.js.map